import Configs from 'configs';

const EV_TRACK_ENDPOINT = Configs.API_ENDPOINT;

export { EV_TRACK_ENDPOINT };
